/*global renderRecaptcha*/
window.onloadCallback = function () {
	renderRecaptcha();
}

/**
 * Loads the form via an ajax function
 */
export function rerun_gravity_forms_scripts()
{
	let selector = $('.body-wrapper').find('.gfid');
	if( selector.length > 0 )
	{
		let yourForm = selector.parent(),
			gfItem = yourForm.find('.gfid'),
			gfNum = gfItem.attr('data-id'),
			gfId = parseInt(gfNum),
			gfTitle = gfItem.attr('data-title'),
			gfDesc = gfItem.attr('data-descr'),
			gfAjax = gfItem.attr('data-ajax');

		if (yourForm.length) {

			$.ajax({
				type: 'GET',
				// Make sure this matches what you set in your wp_enqueue_script
				url: Ajax.url,
				data: {
					action: 'load_gravity_form',
					formid: gfId,
					formtitle: gfTitle,
					formdescr: gfDesc,
					formajax: gfAjax,
					current_url: window.location.href,
				},
			}).done(function (data) {
				yourForm.html(data);
				let scripts = yourForm.find('script');
				scripts.each(function(){
					let text = $(this).text();
					eval(text);
				});
			});
		}
	}
}

export function rerun_embbeded_blogpost_scripts()
{
	// Check if there is a Hubspot form - they currently do not work with swup
	let hs_forms = $('.hbspt-form');
	if( hs_forms.length > 0 )
	{
		// Reload the page
		window.location.reload();
	}

	// Find scripts inside the single-post__content-lockup and run them on swup page change
	let selector = $('.body-wrapper').find('.single-post__content-lockup');

	if(selector.length > 0)
	{
		selector.each(function(){
			let scripts = $(this).parent().find('script');
			scripts.each(function(){
				let text = $(this).text();
				eval(text);
			});
		});
	}
}



// WEBPACK FOOTER //
// ./scripts/modules/forms.js